<template lang="pug">
section.empty-box
  .col
    .h1-title(style="line-height: 1.2;") {{title ? title : $t('noActualTickets')}}
    .support-text(v-if="!isArena") {{sup ? sup : $t('goToDomain').replace(/%domainName%/, currentDomain)}}
    arc-button(v-if="action == 'afisha' && !isArena && !hideRedirect", :name="`${$t('chooseEvent')}`", @click="toAfisha()", accent)
    arc-button(v-if="action == 'videos' && !isArena && !hideRedirect", :name="`${$t('chooseVideo')}`", @click="toVideos()", accent)
  img(src="@/assets/png/non-tickets.png", v-if="!isArena")
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: false,
      default: '',
    },
    sup: {
      type: String,
      require: false,
      default: '',
    },
    action: {
      type: String,
      require: false,
      default: 'afisha',
    },
  },
  name: 'empty',
  data: () => ({
    isArena: false,
    currentDomain: '',
    hideRedirect: false,
  }),
  methods: {
    toAfisha() {
      window.open(`${window.location.host.includes('guru.ge') ? 'https://guru.ge' : 'https://24afisha.by'}`);
    },
    toVideos() {
      window.open('https://24afisha.by/ru/minsk/videos/packages');
    },
  },
  mounted() {
    if (window.location.href.match(/minskarena/)) this.isArena = true;
    this.currentDomain = window.location.hostname;
    if (window.location.host.includes('guru.ge') && !this.$route.path.includes('tickets')) this.hideRedirect = true;
  },
};
</script>

<style lang="scss">
.empty-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  margin-left: 30px;
  margin-right: 25px;
  > .col {
    justify-content: flex-start;
    align-items: flex-start;
    > .support-text {
      min-height: 97px;
      max-height: 97px;
      height: 97px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
</style>
